var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.sortByItems,"value":_vm.selectedSort,"menu-props":{ maxHeight: '90vh' },"hide-details":"","label":"Sort by","append-icon":"keyboard_arrow_down"},on:{"change":function($event){return _vm.updateSort($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }